var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._l((_vm.formLayoutFieldComponents),function(ref,index){
var fieldComponent = ref.fieldComponent;
var fieldLabel = ref.fieldLabel;
return [(fieldComponent)?_c(fieldComponent.previewComponent,_vm._b({key:index,tag:"component",attrs:{"label":fieldLabel,"name":fieldComponent.name,"value":_vm.previewFieldValue(fieldComponent.name)}},'component',Object.assign({}, fieldComponent.props,
        fieldComponent.attrs),false)):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }